import { useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';
import img from '../../assets/images/register.png';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import ChangePageAuth from '../../components/ChangePageAuth';
import FormAuth from '../../components/FormAuth';
import GroupCheck from '../../components/GroupCheck';
import GroupInput from '../../components/GroupInput';
import useErrors from '../../hooks/useErrors';
import { useCheckEmailExists } from '../../hooks/mutations/useUserMutations';
import { useStore } from '../../stores';
import EmailsService from '../../services/EmailsService';
import isEmailValid from '../../utils/isEmailValid';
import * as styles from './styles';

export default function ModelRegister() {
  const [email, setEmail] = useState('');
  const [termAccept, setTermAccept] = useState(false);
  const [emailAccept, setEmailAccept] = useState(false);

  const navigate = useNavigate();
  const { mutate: checkEmail, isPending } = useCheckEmailExists();

  const { setUserData, setVerification } = useStore(
    useShallow((state) => ({
      setUserData: state.setUserData,
      setVerification: state.setVerification,
    }))
  );

  const { setError, removeError, getErrorMessageByFieldName, errors } =
    useErrors();

  function handleEmail(e) {
    setEmail(e.target.value);
    removeError('email');
  }

  function handleTermAccept(e) {
    setTermAccept(e.target.checked);
    removeError('term');
  }

  function handleEmailAccept(e) {
    setEmailAccept(e.target.checked);
  }

  function onSubmit() {
    if (!email) {
      setError({ field: 'email', message: 'O email está vazio' });
      return;
    }

    if (!termAccept) {
      setError({ field: 'term', message: 'É nescessário aceitar os termos' });
      return;
    }

    if (!isEmailValid(email)) {
      setError({ field: 'email', message: 'O email não é valido' });
      return;
    }

    checkEmail(email, {
      onSuccess: async ({ existing }) => {
        if (existing) {
          setError({ field: 'email', message: 'O email já está registrado!' });
          return;
        }

        await EmailsService.sendEmail(email);

        const body = { email, emailAccept };

        setUserData(body);
        setVerification(1);
        navigate('/modelregister/v1');
      },
      onError: () => {
        toast.error('Erro ao enviar código!');
      },
    });
  }

  const isFormValid = Boolean(email && termAccept) && errors.length === 0;

  return (
    <FormContainer>
      <Center className="center">
        <styles.Img>
          <img src={img} alt="registro" />
        </styles.Img>

        <FormAuth
          onSubmit={onSubmit}
          // onGoogle={() => alert('Falta o google')}
          // googleText="Cadastrar-se com o Google"
          next
          buttonTitle="Continuar"
          buttonLinkText="Já possui conta? Entre agora!"
          buttonLink="/modellogin"
          isLoading={isPending}
          formValid={isFormValid}
        >
          <GroupInput error={getErrorMessageByFieldName('email')}>
            <label>Email*</label>
            <input
              type="text"
              placeholder="Digite seu email*"
              value={email}
              onChange={handleEmail}
            />
          </GroupInput>

          <div className="group">
            <GroupCheck
              check={termAccept}
              error={getErrorMessageByFieldName('term')}
            >
              <input
                type="checkbox"
                checked={termAccept}
                onChange={handleTermAccept}
              />
              <label>Li e aceito os</label>
              <Link to="/term">termos de uso</Link>
            </GroupCheck>

            <GroupCheck check={emailAccept}>
              <input
                type="checkbox"
                checked={emailAccept}
                onChange={handleEmailAccept}
              />
              <label>Quero receber novidades por email</label>
            </GroupCheck>
          </div>
        </FormAuth>

        <ChangePageAuth
          link="/clientregister"
          text="É um cliente? Cadastre-se"
        />
      </Center>
    </FormContainer>
  );
}
